import { useEffect, type RefObject } from "react";

function startAnimatedPlaceholderRotation(
    inputEl: HTMLInputElement | null,
    texts: string[],
    intervalMs = 4000,
    animDurationMs = 750
): ReturnType<typeof setInterval> | undefined {
    if (!inputEl || !texts.length) return;
    const wrapper = inputEl.closest('.algoliaAutocompleteForm__searchBar');
    if (!wrapper) return;
    const container = wrapper.querySelector<HTMLDivElement>('.dynamicPlaceholders');
    if (!container) return;
    inputEl.placeholder = '';
    let idx = 0;

    container.innerHTML = '';

    let current = document.createElement('span');
    current.className = 'placeholder-text current';
    current.innerHTML = texts[idx];
    container.appendChild(current);

    function rotate() {
        if (!container) return;
        container.querySelectorAll<HTMLSpanElement>('.placeholder-text:not(.current)')
            .forEach((s) => {
                if (s.parentNode === container) {
                    container.removeChild(s);
                }
            });

        const nextIdx = (idx + 1) % texts.length;
        const next = document.createElement('span');
        next.className = 'placeholder-text';
        next.innerHTML = texts[nextIdx];
        container.appendChild(next);

        void next.getBoundingClientRect();
        current.classList.add('slide-out');
        next.classList.add('slide-in');

        setTimeout(() => {
            if (current && current.parentNode === container) {
                container.removeChild(current);
            }
            if (next && next.parentNode === container) {
                next.classList.remove('slide-in');
                next.classList.add('current');
                current = next;
                idx = nextIdx;
            }
        }, animDurationMs);
    }

    rotate();
    return setInterval(rotate, intervalMs);
}

export function useAnimatedPlaceholder(
    inputRef: RefObject<HTMLInputElement | null>,
    placeholderTexts: string[],
    isVisible?: boolean
) {
    useEffect(() => {
        let rotator: ReturnType<typeof setInterval> | undefined;

        const timeoutId = setTimeout(() => {
            if (inputRef.current && placeholderTexts.length > 0 && (isVisible === undefined || isVisible)) {
                rotator = startAnimatedPlaceholderRotation(
                    inputRef.current,
                    placeholderTexts,
                    4000,
                    750
                );
            }
        }, 100);

        return () => {
            clearTimeout(timeoutId);
            if (rotator) clearInterval(rotator as unknown as number);
        };
    }, [inputRef, placeholderTexts, isVisible]);
}